import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  FAQ: {
    path: `${baseRoutes.userBaseRoutes}faq`,
  },
};

export default accessRoute;
